import { HELIX_NODE_ADDRESS } from '@/global/configs/common.config';

export const ALLOW_GIFT: string[] = [HELIX_NODE_ADDRESS];

export const ORIGINAL_URL: string[] = [
  'localhost',
  'nodesale.lfg.inc',
  'dev-nodesale.lfg.inc',
  'dev-client.bsc.coresale.lfg.inc',
  'prod-client.bsc.coresale.lfg.inc',
  'stag-client.nodesale.lfg.inc',
  'stage-client.coresale.lfg.inc',
];
